<template>
  <div class="ParticipantMoreMenu__wrapper">
    <i class="ParticipantMoreMenu__icon icon-ic_more"
       @click="openMoreMenu"></i>
    <div class="ParticipantMoreMenu__container"
         v-if="isOpen">
      <div class="ParticipantMoreMenu__overlay"
           v-prevent-parent-scroll
           @click="hideMoreMenu"></div>
      <div class="ParticipantMoreMenu__dropdown"
           :style="style">
        <div class="ParticipantMoreMenu__action"
             v-for="action in actions"
             v-if="!action.disabled"
             @click="action.handler">
          {{ action.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api';

  export default {
    name: 'ParticipantMoreMenu',
    props: {
      user: {
        required: true
      },
      name: {}
    },
    data() {
      return {
        isOpen: false,
        actions: {},
        style: {}
      };
    },
    methods: {
      openMoreMenu() {
        this.isOpen = true;
        this.setActions();
        this.setPosition();
      },
      setPosition() {
        const menu_width = 210;
        const position = this.$el.getBoundingClientRect();
        const top = `${position.top + 5}px`;
        let left = `${position.left}px`;
        const vw = window.innerWidth;
        if ((vw - menu_width) <= position.right) {
          left = `${(position.left + position.width) - menu_width}px`;
        }
        this.style = { top, left };
      },
      hideMoreMenu() {
        this.isOpen = false;
      },
      setActions() {
        this.actions = {
          mute: {
            label: `Mute ${this.name}`,
            handler: () => {
              this.$store.dispatch('muteUser', this.user.userId);
              this.isOpen = false;
            },
            disabled: this.user.isMuted
          },
          admin: {
            label: `${this.user.isAdmin ? 'Remove' : 'Give'} ${this.name} Admin Rights`,
            handler: () => {
              this.$store.dispatch('putAdminRights', {
                userId: this.user.userId,
                isAdmin: !this.user.isAdmin
              });
              this.isOpen = false;
            }
          },
          kick: {
            label: `Remove ${this.name} from Call`,
            handler: () => {
              this.$store.dispatch('kickUser', this.user.userId);
              this.isOpen = false;
            }
          }
        };
      }
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// participant-more-menu.vue?7cc72ce8